import { loadImage } from "utils/loadImage";
import { MONCO_LOGO_SRC } from "./constants";

export const tryLoadLogo = async (): Promise<HTMLImageElement | null> => {
  try {
    return await loadImage(MONCO_LOGO_SRC);
  } catch {
    return null;
  }
};
